import React from "react"

export default props => (
    <div className={`row ${props.isCentered ? "row--centered" : ""}`}>
        {props.children}
    </div>
)
